import officialscoresheetStyles from '../../officialscoresheet.module.css';

const {
  rotationScore,
  rotationScoreGroup,
  rotationScoreLabel,
  rotationScoreValue,
} = officialscoresheetStyles;

export function ScoreSheetRounds({ data, apparatus }) {
  return (
    <div className={rotationScore}>
      <div className={rotationScoreGroup}>
        <span className={rotationScoreLabel}>{`${apparatus} Score:`}</span>
        <span className={rotationScoreValue}>{data?.eventScore}</span>
      </div>
      <div className={rotationScoreGroup}>
        <span className={rotationScoreLabel}>Running Score:</span>
        <span className={rotationScoreValue}>{data?.runningScore}</span>
      </div>
    </div>
  );
}
